import HeroSlider from '../components/HeroSlider';
import FeaturedContent from '../components/FeaturedContent';
import ContactInfo from '../components/ContactInfo';

const Home = () => {
  return (
    <main>
      <HeroSlider />
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          <div className="lg:col-span-2">
            <FeaturedContent />
          </div>
          <div className="lg:col-span-1">
            <ContactInfo />
          </div>
        </div>
      </div>
    </main>
  );
};

export default Home;
